import React from 'react';
import { Radio, Space } from 'antd';
import type { FH110 } from '../../../services/pwh201Api';
import { PAYMENT_CATEGORIES } from '../helpers';

interface Tab1Props {
  formData: Partial<FH110>;
  isEditing: boolean;
  setField: <K extends keyof FH110>(field: K, value: FH110[K]) => void;
  entryPersonName: string;
}

const Tab1Category: React.FC<Tab1Props> = React.memo(({ formData, isEditing, setField, entryPersonName }) => {
  return (
    <div className="pwh201-tab-content">
      <label className="pwh201-section-title" data-contract-field="fh110_22">請款類別</label>
      <Radio.Group
        data-contract-field="fh110_22"
        value={formData.fh110_22 || ''}
        onChange={e => setField('fh110_22', e.target.value)}
        disabled={!isEditing}
      >
        <Space direction="vertical">
          {PAYMENT_CATEGORIES.map(cat => (
            <Radio key={cat.value} value={cat.value}>
              <span className="pwh201-category-label">{cat.label}</span>
              <span className="pwh201-category-desc">{cat.description}</span>
            </Radio>
          ))}
        </Space>
      </Radio.Group>
      <div className="pwh201-entry-person">
        <label data-contract-field="fh110_93">入單人員</label>
        <span data-contract-field="fh110_93">{entryPersonName || '-'}</span>
      </div>
    </div>
  );
});

Tab1Category.displayName = 'Tab1Category';
export default Tab1Category;
